<template>
    <div>
        <commBanner :obj="obj"></commBanner>
        <titleHead :headTitle="headTitle"></titleHead>
        <div class="w60 mb-60">
            <div class="mt-30">
                <div class="info_detail_desc">
                    <h4>{{detail.title}}</h4>
                    <p class="mt-20 info_detail_desc" v-html="detail.content"></p>
                    <p>{{keepTextStyle(detail.descrption)}}</p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import commBanner from '../../common/commBanner'
import titleHead from  '../../common/titleHead'
import {helpDetail} from '@/api/coment'
export default {
   components:{commBanner,titleHead},
   data(){
    return{
        headTitle:"帮助详情",
        obj:{
           title:'帮助详情',   
           isShow:false,
           roleType:'',
           personalType:''
        },
        detail:{}
    }
   },
   created(){
     let id = this.$route.query.id;
     this.gethelpDetail(id);
     if(this.$store.state.user.userInfo != null){
        this.obj.roleType = this.$store.state.user.userInfo.type;  
        this.obj.personalType = 9;
     }
   },
   methods:{
       gethelpDetail(id){
		   helpDetail({id:id}).then((res)=>{
			   if(res.code ==0){
				   this.detail= res.faq
			   }
		   }).catch((err)=>{})
       },
      keepTextStyle(val){
        return (val +'').replace(/(<br[^>]*>|\s*)/g,'');
      },
   }, 
}
</script>
<style scoped>
.w60{
    width: 60%;
    margin: 0 auto;
}
.mb-60{
    margin-bottom: 60px;
}
.mt-20{
    margin-top: 20px;
}
.mt-50{
    margin-top: 50px;
}
.info_detail_desc{
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
}
.info_detail_desc h4{
    font-size: 24px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #343434;
    display: flex;
    justify-content: center;
}
.info_detail_desc p{   
   line-height: 23px;
}

.info_detail_desc >>>iframe{ 
   width: 598px;
   height: 337px;
   object-fit: fill;
}
.upgrade{
    width: 188px;
    height: 41px;
    background: linear-gradient(-20deg, #FFBC02, #FF7602);
    border-radius: 21px;
    line-height: 41px;
    text-align: center;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #FFFFFF;
    margin-right: 40px;
}
.upgrade:hover{
    cursor: pointer;
}
.notes{
    margin-top: 40px; 
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
}
.picture{
    overflow: hidden;
}
.picture img{
   width: 100%;
   height: 346px;
   transition: all 0.6s;
}
.picture img:hover{
    transform: scale(1.4);
}
.help>>>img{
    /* width: 100%; */
    /* height: 346px; */
    margin-top: 15px;
}


.help>>>.ql-align-center{
  display: flex;
  justify-content: center;
}
</style>


// WEBPACK FOOTER //
// src/view/other/help_detail.vue